import React from 'react';

import Context     from '../../../../../../context';
import validations from '../../../../../../validations';

import { useFormik         } from 'formik';
import { useTranslation    } from 'react-i18next';
import { locationNamespace } from '../../../../../../types/location.namespace';

import {
  CustomIcon,
  CustomInput,
  CustomModal,
  CustomButton2,
  ResponsiveView,
  LocationDropdowns,
} from '../../../../../../components';

import './index.sass';
import SelectArea from "./SelectArea";

const Create: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  // const [location, setLocation] = React.useState<Array<string>>([]);
  const [selectedCity, setSelectedCity] = React.useState<locationNamespace.city.index>();
  const [selectedProvince, setSelectedProvince] = React.useState<locationNamespace.province.index>();
  const [errors, setErrors] = React.useState<any>(undefined);
  const { showModal, setShowModal, createFunction, isLoading } = React.useContext(Context.Location.Area);
  const { t } = useTranslation();

  const [selectedArea, setSelectedArea] = React.useState<any>(undefined);

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  const formik = useFormik<locationNamespace.area.create>({
    enableReinitialize: true,
    initialValues: {
      isCapital: false,

      key        : undefined,
      name       : '',
      prefix     : undefined,
      description: undefined,

      city     : undefined,
      province : undefined,

      code      : undefined,
      population: undefined,

      // location: {
      //   type: 'Point',
      //   coordinates: [NaN, NaN]
      // },
      //
      // polygon: {
      //   type: 'Polygon',
      //   coordinates: [[[NaN, NaN]]]
      // }
    },
    validationSchema: validations.location.province.create,
    onSubmit: (values: locationNamespace.area.create, { setSubmitting }) => {
      if (!selectedCity) return setErrors({city: 'اتنخاب شهر اجباری است.'});
      console.log(values);
      const newValues: locationNamespace.area.create = {
        ...values,
        city     : selectedCity._id,
        // location: location ? {
        //   type: 'Point',
        //   coordinates: [
        //     location[0] ? Number(location[0]) : Number(selectedCity.location?.coordinates[0]),
        //     location[1] ? Number(location[1]) : Number(selectedCity.location?.coordinates[1]),
        //   ]
        // } : undefined,
      }
      Promise.resolve(createFunction!(newValues)).catch(() => setSubmitting(false));
    },
  });

  async function submitHandler(): Promise<void> {
    await formik.submitForm();
  }

  // function handleChangeLocation(lat: any, lng: any): void {
  //   setLocation([lat, lng]);
  // }

  function onSelectProvince(province: locationNamespace.province.index): void {
    setSelectedProvince(province);
    setErrors({province: undefined});
  }

  function onSelectCity(city: locationNamespace.city.index): void {
    setSelectedCity(city);
    setErrors({city: undefined});
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section id="parent-create-modal-container">
      <CustomIcon
        icon="fa-sharp fa-solid fa-circle-plus"
        size="medium"
        hoverTitle={'ساخت منطقه'}
        onClick={() => {setShowModal!("CREATE")}}
      />
      <form onSubmit={submitHandler}>
        <CustomModal label='ساخت منطقه' open={showModal === "CREATE"} onClose={() => setShowModal!("NONE")}>
          <ResponsiveView.Container className="create-form-content">
            <br/>
            <hr/>
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column medium={6}>
                <LocationDropdowns.Province
                  onSelectItem = { onSelectProvince }
                  defaultItem  = { selectedProvince }
                  errorText    = { errors?.province }
                  isError      = { errors?.province }
                />
              </ResponsiveView.Column>
              <ResponsiveView.Column medium={6}>
                <LocationDropdowns.City
                  selectedProvince= { selectedProvince }
                  onSelectItem    = { onSelectCity     }
                  defaultItem     = { selectedCity     }
                  errorText       = { errors?.city     }
                  isError         = { errors?.city     }
                />
              </ResponsiveView.Column>
            </ResponsiveView.Row>
            <hr/>
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column medium={6}>
                <CustomInput
                  id            = 'name'
                  name          = 'name'
                  label         = 'نام منطقه'
                  value         = { formik.values.name }
                  error         = { formik.errors.name && formik.touched.name }
                  errorText     = { formik.errors.name }
                  formikProps   = { {onBlur: formik.handleBlur} }
                  onValueChange = { formik.handleChange }
                />
              </ResponsiveView.Column>
              <ResponsiveView.Column medium={6}>
                {/*<CustomCheckbox label='مرگز استان میباشد'/>*/}
              </ResponsiveView.Column>
            </ResponsiveView.Row>
            <br/>
            <ResponsiveView.Row className='form-row'>
              <ResponsiveView.Column small={12}>
                <SelectArea
                  setAreaState={setSelectedArea}
                  areaState={selectedArea as { lat: number; lng: number }[]}
                  zoom={selectedCity ? 12 : selectedProvince ? 8 : 6}
                  defaultAreaLatLng={
                    selectedCity
                      ? [
                        selectedCity?.location?.coordinates[0] as number,
                        selectedCity?.location?.coordinates[1] as number,
                      ]
                      : selectedProvince
                        ? [
                          selectedProvince?.location?.coordinates[0] as number,
                          selectedProvince?.location?.coordinates[1] as number,
                        ]
                        : [32, 53]
                  }
                />
              </ResponsiveView.Column>
            </ResponsiveView.Row>
            <br />
            <hr/>
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column large={6} medium={6} small={12}>
                <CustomButton2
                  isLoading={isLoading}
                  onClick={() => setShowModal!("NONE")}
                  title={t("cancel")}
                  type="danger"
                />
              </ResponsiveView.Column>
              <ResponsiveView.Column large={6} medium={6} small={12}>
                <CustomButton2 isLoading={isLoading} onClick={submitHandler} title={t("submit")}/>
              </ResponsiveView.Column>
            </ResponsiveView.Row>
          </ResponsiveView.Container>
        </CustomModal>
      </form>
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default Create;
